<template>
    <div>
        <!-- tabs -->
        <v-tabs v-model="tab" show-arrows height="35">
            <v-tab
                v-if="!firstLevel"
                class="text-capitalize "
                :to="{ name: 'double-visits'}"
            >
                Double visit reports
            </v-tab>

            <v-tab
                class="text-capitalize "
                :to="{ 
                    name: 'administrative-reports'
                }"
            >
                Administrative Reports
            </v-tab>

            <v-tab
                class="text-capitalize "
                :to="{ 
                    name: 'administrative-visits'
                }"
            >
                Administrative visits
            </v-tab>
          
            <v-tabs-slider color="primary"></v-tabs-slider>
        </v-tabs>
        <v-divider class="mb-2"/>

        <!-- child page -->
        <loader v-if="loading"/>
        <router-view v-else/>
    </div>
</template>

<script>
import { roleName } from '@/helpers/enums'
import { firstLevel } from '@/configs/global.config'
export default {
    data() {
        return {
            tab: 0,
            loading: false,
            roleName,
            firstLevel
        }
    }
}
</script>
